import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { authAPI } from "../services/api";
import FilledButton from "../components/FilledButton";
import { Email, Lock } from "@mui/icons-material";
import toast from "react-hot-toast";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (!email || !password) {
      toast.error("Please fill in all fields");
      return;
    }

    setLoading(true);

    try {
      const response = await authAPI.login(email, password);
      localStorage.setItem("token", response.access_token);
      toast.success("Login successful!");
      navigate("/dashboard");
    } catch (error) {
      // Handle different types of errors
      let errorMessage = "Login failed. Please try again.";
      
      if (error.response) {
        // Server responded with error status
        errorMessage = error.response.data?.message || errorMessage;
      } else if (error.request) {
        // Request was made but no response received
        errorMessage = "Network error. Please check your connection.";
      } else {
        // Something else happened
        errorMessage = error.message || errorMessage;
      }
      
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md border border-borderLight">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-primaryGreen mb-2">
            License Server
          </h1>
          <p className="text-primaryGray">Sign in to manage licenses</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-primaryText mb-2">
              Email
            </label>
            <div className="relative">
              <Email className="absolute left-3 top-1/2 transform -translate-y-1/2 text-essentialGray w-5 h-5" />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full pl-10 pr-4 py-2 border border-borderLight rounded-lg focus:outline-none focus:ring-2 focus:ring-primaryGreen focus:border-transparent"
                placeholder="Enter your email"
                required
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-primaryText mb-2">
              Password
            </label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-essentialGray w-5 h-5" />
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full pl-10 pr-4 py-2 border border-borderLight rounded-lg focus:outline-none focus:ring-2 focus:ring-primaryGreen focus:border-transparent"
                placeholder="Enter your password"
                required
              />
            </div>
          </div>

          <FilledButton
            text="Sign In"
            btnType="submit"
            showLoader={loading}
            isDisabled={loading}
            width="full"
          />

          <div className="text-center text-sm text-primaryGray">
            Don't have an account?{" "}
            <Link
              to="/signup"
              className="text-primaryGreen hover:text-primaryGreenHover font-medium"
            >
              Sign up
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}

